/* RESPONSIBLE TEAM: team-ai-agent-2 */

export type GroupSummaryWireFormat = {
  id: string;
  group_name: string;
};

export class GroupSummary {
  id: number;
  name: string;

  constructor(id: number, name: string) {
    this.id = id;
    this.name = name;
  }

  static deserialize(data: GroupSummaryWireFormat): GroupSummary {
    return new GroupSummary(Number(data.id), data.group_name);
  }
}
